<template>
    <div v-if="testoDomanda !== null" class="domanda-inoltrata-container">
        <div class="title">{{ intl[$store.state.lang]["title"]}}</div>
        <div class="domanda-text">
            {{ testoDomanda }}
        </div>
    </div>
</template>

<script>
import intl from "./intl/intl";

export default {
    name: "domandaInoltrata",
    mounted() {},
    props: {
        
        testoDomanda: {
            type: String,
            default: null
        },
         
    },
    created() {
      
    },
    

    data: function () {
        return {
            intl: intl,
            
        };
    },
    methods: {
      
    },
    watch: {
       
    },
    computed: {
        
    },
};
</script>
